import { FC } from 'react';

import { Svg, SvgProps } from '../../components/Svg/Svg.styles';

export const AddMemberAltIcon: FC<SvgProps> = (props) => (
  <Svg {...props} width="16" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-no-fill>
    <path d="M14.25 6V8.25M14.25 8.25V10.5M14.25 8.25H12M14.25 8.25H16.5M10.125 4.875C10.125 6.32475 8.94976 7.5 7.50001 7.5C6.05026 7.5 4.87501 6.32475 4.87501 4.875C4.87501 3.42525 6.05026 2.25 7.50001 2.25C8.94976 2.25 10.125 3.42525 10.125 4.875ZM2.57502 12.6466C3.50576 10.9154 5.26617 9.75 7.50001 9.75C9.73385 9.75 11.4943 10.9154 12.425 12.6466C13.0528 13.8143 11.9794 15 10.6536 15H4.34645C3.02062 15 1.94719 13.8143 2.57502 12.6466Z" stroke="currentcolor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);
